import { render } from "./CWrapper.vue?vue&type=template&id=d8fa0114"
import script from "./CWrapper.vue?vue&type=script&lang=js"
export * from "./CWrapper.vue?vue&type=script&lang=js"

import "./CWrapper.vue?vue&type=style&index=0&id=d8fa0114&lang=less"

import exportComponent from "/home/gitlab-runner/builds/LUZizzTB/0/unicorn/frontend/unicorn-fe-support/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__